import dayjs from './DayjsUtil'
import { generarTextoAnioMesDia } from './GenerarTextoAnioMesDiaUtil'

/**
 * @description Calcula la duración entre dos fechas en años, meses y días
 *
 * @author ana.carrasco  Hábil MX
 * @version 1.0.0, 20/02/2023
 * @param fechaInicio es fecha inicial de un evento ('DD/MM/YYYY')
 * @param fechaFin es la fecha final de un evento ('DD/MM/YYYY')
 * @returns string con duracion en dias, meses y/o años en numero entero
 */
export const calcularAnioMesDia = (fechaInicio: string, fechaFin: string) => {
  const numeroDiasEntreFechas = (fechaInicio: string, fechaFin: string) => {
    const arregloFechaInicio = fechaInicio.split('/')
    const arregloFechaFin = fechaFin.split('/')
    const miliSegFechaInicio = Date.UTC(
      Number(arregloFechaInicio[2]),
      Number(arregloFechaInicio[1]) - 1,
      Number(arregloFechaInicio[0])
    )
    const miliSegFechaFin = Date.UTC(
      Number(arregloFechaFin[2]),
      Number(arregloFechaFin[1]) - 1,
      Number(arregloFechaFin[0])
    )
    const diff = miliSegFechaFin - miliSegFechaInicio
    return Math.floor(diff / (1000 * 60 * 60 * 24))
  }
  const diasEnMeses = (mes: number, anio: number) => {
    return dayjs(new Date(anio, mes, 0)).get('date')
  }

  const sumaDiasAFecha = (numeroDias: string, fecha: string) => {
    const arregloFecha = fecha.split('/')
    let nuevaFecha = dayjs(`${arregloFecha[2]}/${arregloFecha[1]}/${arregloFecha[0]}`)
    nuevaFecha = nuevaFecha.set('date', nuevaFecha.get('date') + parseInt(numeroDias))
    return `${nuevaFecha.get('date')}/${nuevaFecha.get('month') + 1}/${nuevaFecha.get('year')}`
  }

  const diasTotal = numeroDiasEntreFechas(fechaInicio, fechaFin)
  let diasCalculadosAux = 0
  let cantidadDias = 0
  let cantidadMeses = 0
  let cantidadAnios = 0
  while (diasCalculadosAux < diasTotal) {
    const arrayDateStart = fechaInicio.split('/')
    const diasDelMes = diasEnMeses(parseInt(arrayDateStart[1]), parseInt(arrayDateStart[2]))
    diasCalculadosAux = diasCalculadosAux + diasDelMes
    cantidadDias = Math.abs(numeroDiasEntreFechas(fechaInicio, fechaFin))
    fechaInicio = sumaDiasAFecha(diasDelMes.toString(), fechaInicio)

    if (diasCalculadosAux <= diasTotal) {
      cantidadMeses++
      if (cantidadMeses === 12) {
        cantidadAnios++
        cantidadMeses = cantidadMeses - 12
      }
    }
  }

  const textoAniosMesesDias = generarTextoAnioMesDia(cantidadAnios, cantidadMeses, cantidadDias)

  return [
    textoAniosMesesDias[0],
    textoAniosMesesDias[1],
    textoAniosMesesDias[2],
    textoAniosMesesDias[3],
  ]
}
